import ReactGA from 'react-ga';
import parseBoolean from './booleanParser';
import { getEnv } from './envUtils';

const initializeGoogleAnalytics = () => {
    ReactGA.initialize(
        'UA-47580195-14',
        {
            titleCase: false,
            debug: !parseBoolean(getEnv('REACT_APP_GA_ACTIVE')),
            testMode: !parseBoolean(getEnv('REACT_APP_GA_ACTIVE')),
        },
    );
};

const trackEvent = ({ category, action, label }) => {
    if (!category || !action) return;

    ReactGA.event({
        category,
        action,
        ...(label && { label }),
    });
};

const trackPageview = (page) => {
    if (!page) return;

    ReactGA.pageview(page);
    ReactGA.set({ page });
};

const trackingUtils = {
    initializeGoogleAnalytics,
    trackEvent,
    trackPageview,
};

export default trackingUtils;
